import { useState, useCallback } from 'react';

export const useHover = () => {
  const [isHovered, setHovered] = useState(false);

  const onMouseEnter = useCallback(() => setHovered(true), []);
  const onMouseLeave = useCallback(() => setHovered(false), []);

  return [
    isHovered,
    {
      onMouseEnter,
      onMouseLeave,
    },
  ];
};
